import {Modal} from "react-bootstrap";
import {useThemeMode} from "../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider";
import {useIntl} from "react-intl";

type Props = {
    keyInfo: string
    show: boolean
    setShow:Function
    onConfirmCancel: () => void
    keyDesc: string
}
export const WarningModal = (props:Props) => {
    const {mode} = useThemeMode()
    const intl = useIntl()
    const onCancel = () => props.setShow(false)
    return (
        <Modal show={props.show} centered>
            <div className='text-center p-5 w-100' data-bs-theme={mode}>
                <div
                    className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                    data-bs-theme={mode}
                >
                    <div className='d-flex align-items-center justify-content-between'>
                        <div className='fw-bolder text-gray-700 py-3'>
                            {intl.formatMessage({id: props.keyInfo})}
                        </div>
                        <div className='p-1 cursor-pointer' onClick={onCancel}>
                            <i className='fa fa-close text-danger'></i>
                        </div>
                    </div>
                    <div className={'text-start px-4 py-3'}>
                        <div>{intl.formatMessage({id: props.keyDesc})}</div>
                    </div>
                    <div className='d-flex align-items-center justify-content-center'>
                        <button
                            className={'btn btn-primary'}
                            onClick={onCancel}
                        >
                            J'ai compris
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
